import { CraneNavigationApiResponse, CraneSearchApiOptions, CraneSearchApiRequest, CraneSearchApiResponse } from "@shared/types/CraneTypes";
import { apiGet, apiPost } from "./apiHelper";
import { getRoutePathByPageType } from "../findPathForSystemSite";
import { fetchContent } from "./apiGetContent";

export const validateCraneSerial = async (
    serialNumber: string,
    culture: string
): Promise<CraneSearchApiResponse> => {
    const request: CraneSearchApiRequest = {
        serialNumber,
        culture,
        productIdOrName: "",
        categoryId: "",
        pageNumber: 1,
        pageSize: 1,
        inStock: null
    }
    return await searchCraneItems(request);
};

export const searchCraneItems = async (
    request: CraneSearchApiRequest,
    signal?: AbortSignal
): Promise<CraneSearchApiResponse> => {
    const { serialNumber, productIdOrName, productId, categoryId, inStock, culture, pageNumber, pageSize } = request;
    return await apiPost<CraneSearchApiResponse, CraneSearchApiOptions>(
        `/api/BOMList/${serialNumber}?culture=${culture.toLowerCase()}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
        {
            serialNumber,
            productIdOrName: productIdOrName || "",
            productId,
            categoryId,
            inStock
        },
        { signal }
    );
};

export const fetchCraneProduct = async (
    serialNumber: string,
    productId: string,
    culture: string
): Promise<CraneSearchApiResponse> => {
    const request: CraneSearchApiRequest = {
        serialNumber,
        culture,
        productId,
        productIdOrName: "",
        categoryId: "",
        pageNumber: 1,
        pageSize: 1,
        inStock: null
    }
    return await searchCraneItems(request);
};

export const fetchCraneNavigation = async (
    serialNumber: string,
    culture: string
): Promise<CraneNavigationApiResponse> => {
    const response = await apiGet<CraneNavigationApiResponse>(
        `/api/BOMList/${serialNumber}/navigation?culture=${culture.toLowerCase()}`
    );
    return response.data;
};

const getDynamicPagePath = (pathname: string) => {
    const cranePath = getRoutePathByPageType("Crane") || "";

    // If the path is for crane, handle path accordingly
    if (pathname.startsWith(cranePath)) {
        const cranePathSegments = pathname.startsWith("/") ? pathname.split("/").slice(1) : pathname.split("/");
        const filteredPath = `/${cranePathSegments.slice(2).join("/")}`;

        // special handling for crane frontpage
        if( (filteredPath === "" || filteredPath === "/")) {
            return cranePath;
        }

        return filteredPath;
    }
    return pathname
};

export const fetchCraneContentByUrl = async (url: string) => {
    const urlToFetch = getDynamicPagePath(url);
    return await fetchContent(urlToFetch);
};
